export default __webpack_public_path__ + "static/illo-manage-your-wallets-d7293f6f502ffe099a4c133eeeb0bf99.svg";